import Avatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';

import { getUserInitials } from './common';
import { Headline } from '../Typography';

import type { FunctionComponent } from 'react';

const avatarMuiDimension = 4;

const StyledAvatar = styled(Avatar)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.light, // TODO check with UX for proper color token
    height: theme.spacing(avatarMuiDimension),
    width: theme.spacing(avatarMuiDimension),
}));

type SmallAvatarProps = {
    readonly firstName: string;
    readonly lastName: string;
};

export const AvatarSmall: FunctionComponent<SmallAvatarProps> = (props: SmallAvatarProps) => {
    const initials = getUserInitials(props.firstName, props.lastName);

    return (
        <StyledAvatar>
            <Headline variant="h6">{initials}</Headline>
        </StyledAvatar>
    );
};
